import * as tagUtil from "./LogTagData";

const registerSuccessEvent = () => {
  let data = {
    page_event : "view",
    service_application_event : "finish",
    service_application_step : "ebu: self service: registration: success",
    service_application_name : "ebu: self service: registration (transaction)",
    service_application_type : "transaction",
    Set_page_name :"ebu: self service: registration: success",
    complete_registration : "completed"
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
};

const registerErrorEvent = (err) => {
  let data = {
    page_form_event : "error",
    page_errors : err,
    page_name :  "ebu: self service: registration: journey error"
  };

  try {
    window.tagUtil.link(data);
  } catch (e) {
    tagUtil.logError(e);
  }
};

const gsmRegistrationPageLoad = () => {
  let data = {
    page_event: "view",
    page_name: "vodacom: business: self service: registration: gsm billing account",
    page_channel: "accounts",
    page_master_tab: "business",
    page_category: "registration",
    page_type: "content",                                                                             
    service_application_name: "vodacom: business: self service: registration:  gsm billing account",
    service_application_step: "vodacom: business: self service: registration:  gsm billing account form"
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
}

const gsmRegistrationSuccess = () => {
  let data = {
    page_event: "view",
    page_name: "vodacom: business: self service: registration: gsm billing account: success",
    page_channel: "accounts",
    page_master_tab: "business",
    page_category: "registration",
    page_type: "content",                                                                                    
    service_application_name: "vodacom: business: self service: registration:  gsm billing account: success",
    service_application_step: "vodacom: business: self service: registration:  gsm billing account form: success"
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
}

const fixedRegistrationPageLoad = () => {
  let data = {
    page_event: "view",
    page_name: "vodacom: business: self service: registration: fixed billing account",
    page_channel: "accounts",
    page_master_tab: "business",
    page_category: "registration",
    page_type: "content",       
    service_application_event: "finish",                                                                                
    service_application_name: "vodacom: business: self service: registration:  fixed billing account",
    service_application_step: "vodacom: business: self service: registration:  fixed billing account form"
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
}

const fixedRegistrationSuccess = () => {
  let data = {
    page_event: "view",
    page_name: "vodacom: business: self service: registration: fixed billing account: success",
    page_channel: "accounts",
    page_master_tab: "business",
    page_category: "registration",
    page_type: "content",  
    service_application_event: "finish",                                                                                 
    service_application_name: "vodacom: business: self service: registration:  fixed billing account: success",
    service_application_step: "vodacom: business: self service: registration:  fixed billing account form: success"
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
}

const registrationPageLoad = () => {
  let data = {
    page_event : "view",
    page_name: "vodacom: business: self service: registration",
    page_channel: "accounts",
    page_master_tab: "business",
    page_category: "registration",
    page_form_event : "started",
    page_form_name : "ebu: self service: registration form",
    service_application_event: "start",
    service_application_name: "vodacom: business: self service: registration",
    service_application_type : "transaction",
    service_application_step: "vodacom: business: self service: registration form"
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
};

const registrationFormComplete = () => {
  let data = {
    link_type: "o",
    link_name: "vodacom: business: self service: registration: next"
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
}

const fixedRegistrationFormComplete = () => {
  let data = {
    link_type: "o",
    link_name: "vodacom: business: self service: registration: fixed billing account: submit"

  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
}

const loginClickEvent = () => {
  let data = {
    link_type: "o",
    link_name: "vodacom: business: self service: registration: login"
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
}

const registrationFormSubmit = () => {
  let data = {
    link_type: "o",
    link_name: "vodacom: business: self service: registration: gsm billing account: submit"
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
}

const gsmRegistrationNavigateBack = () => {
  let data = {
    link_type: 'o',
    link_name: 'vodacom: business: self service: registration: gsm billing account: go back'
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
}

const fixedRegistrationNavigateBack = () => {
  let data = {
    link_type: 'o',
    link_name: 'vodacom: business: self service: registration: fixed billing account: go back'
  };

  try {
    window.tagUtil.view(data);
  } catch (e) {
    tagUtil.logError(e);
  }
}

export {
  gsmRegistrationPageLoad,
  gsmRegistrationSuccess,
  fixedRegistrationPageLoad,
  fixedRegistrationSuccess,
  fixedRegistrationFormComplete,
  loginClickEvent,
  registrationPageLoad,
  registrationFormComplete,
  registrationFormSubmit,
  registerSuccessEvent,
  registerErrorEvent,
  gsmRegistrationNavigateBack,
  fixedRegistrationNavigateBack
};
